/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import "./firebase";
import { loadFonts } from "./webfontloader";
import vuetify from "./vuetify";
import i18n from "./i18n";
import router from "@/app/router";
import pinia from "@/shared/stores";

// Types
import type { App } from "vue";

export function registerPlugins(app: App) {
  loadFonts();
  app.use(vuetify).use(i18n).use(router).use(pinia);
}
